<main class="admin">
  <div class="admin-form--container">
    <app-admin-form></app-admin-form>
  </div>
</main>
